import {
  AfterViewInit, ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  HostBinding,
  Input,
  OnDestroy,
  OnInit,
  Output, Renderer2
} from '@angular/core';
import {animationFrameScheduler, Subscription} from 'rxjs';

import {GetRegion2Css, GetRegion2Name} from '../../defines/client.const';
import {GetSaseungTxt} from "../../defines/gukeo.func";
import {SaseungHanja} from "../../models/saseung.model";
import {clickOutsideLinkMixin} from "../../mixins/click-outside.mixin";
import {GlobalEventService} from "../../services/global-event/global-event.service";
import {SASEUNG_HANJAS, SaseungHanjaService} from "../../services/saseung-hanja/saseung-hanja.service";

const MAX_HUN_ITEM = 5;
const POPUP_HEIGHT_DELTA = 60;


@Component({
  selector: 'app-hun-popup',
  templateUrl: './hun-popup.component.html',
  styleUrls: ['./hun-popup.component.scss']
})
export class HunPopupComponent extends clickOutsideLinkMixin implements OnInit, AfterViewInit, OnDestroy {
  @HostBinding('class') hostClass = 'link-popup popup-connect type-shadow';
  @Input() hun?: string;
  @Output() close = new EventEmitter<string | null>();
  @Output() viewInit = new EventEmitter<HTMLElement>();

  protected readonly GetRegion2Css = GetRegion2Css;
  protected readonly GetRegion2Name = GetRegion2Name;
  protected readonly GetSaseungTxt = GetSaseungTxt;

  protected countPopupItems = MAX_HUN_ITEM;
  private load$: Subscription | null = null;
  listSaseungHanja: Array<SaseungHanja> | null = null
  private totalSaseungCount = 0;

  public get IsLoading(): boolean {
    return this.load$ !== null;
  }

  public getLeftHunCount(): number {
    return this.totalSaseungCount - this.countPopupItems;
  }

  public getMoreTxt(): string | null {
    const leftHunCount = this.getLeftHunCount();
    if (leftHunCount > 0) {
      return `${leftHunCount}개의 훈이 더 있습니다.`;
    }
    return null;
  }

  constructor(
    public elementRef: ElementRef,
    public renderer: Renderer2,
    public globalEventSvc: GlobalEventService,
    private saseungHanjaSvc: SaseungHanjaService,
    private cdRef: ChangeDetectorRef,
  ) {
    super(elementRef, renderer, globalEventSvc);

    console.warn('HunPopupComponent.constructor()');
  }

  ngOnInit(): void {
    // const parent: HTMLElement = this.elementRef.nativeElement.parentElement;

    // mixin을 이용해서 팝업창 외부를 클릭했는지 체크한다.
    this.coInit(() => this.close.emit(null));

    if (this.hun) {
      this.load$ = this.saseungHanjaSvc.GetHuns(this.hun).subscribe(
        (shInfo: SASEUNG_HANJAS) => {
          console.warn('HunPopupComponent.ngOnInit: shInfo =', shInfo);

          this.totalSaseungCount = shInfo.totalCount;
          this.listSaseungHanja = shInfo.saseungHanjas.slice(0, MAX_HUN_ITEM);
        },
        (error) => {
          console.error('HunPopupComponent.ngOnInit: error', error);
        },
        () => {
          this.load$ = null;
        }
      );
    }
  }

  ngAfterViewInit(): void {
    // TODO: 이 부분은 mixin에서 사용하고 있지만 처리하는 작업은 없다. 책상형에서 사용하지만 앱에서는 필요하지 않아 보인다.
    // this.viewInit.emit(this.elementRef.nativeElement.firstChild);
  }

  ngOnDestroy(): void {
    this.coDestroy();

    // 로딩 하고 있으면, 로딩을 중단한다.
    if (this.load$) {
      this.load$.unsubscribe();
      this.load$ = null;
    }
  }

  public onCloseMore($event: MouseEvent): void {
    console.warn('LinkPopupComponent.onCloseMore');

    $event.stopPropagation();
    $event.preventDefault();

    this.close.emit(this.hun);
  }


  /**
   * 상위 요소로 이벤트 전파를 막는다.
   * @param event
   */
  onVoid(event: MouseEvent): void {
    event.preventDefault();
    event.stopPropagation();
    // this.globalEventSvc.Click(event);
  }

  onItemAfterViewInit() {
    const componentHeight = this.elementRef.nativeElement.offsetHeight;
    const windowHeight = window.innerHeight;

    console.log('LinkPopupComponent.onItemAfterViewInit', componentHeight, windowHeight, this.elementRef.nativeElement);

    if (componentHeight > windowHeight - POPUP_HEIGHT_DELTA) {
      console.warn('remove display', componentHeight, windowHeight - POPUP_HEIGHT_DELTA);
      animationFrameScheduler.schedule(() => {
        --this.countPopupItems;
        this.cdRef.detectChanges();
      });
    }
  }

  onClose($event: MouseEvent) {
    $event.preventDefault();
    $event.stopPropagation();
    this.close.emit(null);
  }
}
